module.exports = __webpack_public_path__ + "static/hunting_trap-9e55f2b8e5dc61744ad2f119c48e0a2a.jpg";